<script setup lang="ts">
import type { Typography } from '~/types/components/base/Typography';

const { element = 'p', type = 'body' } = defineProps<{
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  type?: Typography;
}>();

const inlineClass = computed(() => {
  return [`font-${type}`];
});
</script>

<template>
  <component :is="element" :class="inlineClass" class="app-typography">
    <slot></slot>
  </component>
</template>

<style lang="scss" scoped>
.app-typography {
}
</style>
